import {__} from "./__";

export const getTemplateEvents = () => {
    return {
        'create_invoice': {
            name: __('Vystavenie faktúry'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('v prílohe vám posielame faktúru č. {invoice.number} k objednávke {order.number}.')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', invoice: true, ignore_sources: '', bcc: '' },
            labels: { invoice: __('Pripojiť PDF faktúry ako prílohu') },
        },
        'create_proforma': {
            name: __('Vystavenie zálohovej faktúry'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('v prílohe vám posielame zálohovú faktúru č. {invoice.number} k objednávke {order.number}.')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', invoice: true, ignore_sources: '', bcc: '' },
            labels: { invoice: __('Pripojiť PDF faktúry ako prílohu') },
        },
        'create_cancel': {
            name: __('Vystavenie dobropisu'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('v prílohe vám posielame dobropis č. {invoice.number} k objednávke {order.number}.')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', invoice: true, ignore_sources: '', bcc: '' },
            labels: { invoice: __('Pripojiť PDF faktúry ako prílohu') },
        },
        'paid': {
            name: __('Úhrada faktúry'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('ďakujeme za úhradu faktúry č. {invoice.number}.')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', ignore_sources: '', bcc: '' },
        },
        'send': {
            name: __('Odoslanie zásielky'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('objednávka č. {order.number} bola odoslaná prepravcovi.')}</p><p>${__('Číslo zásielky: {package.number}')}</p><p>${__('Objednávku môžete sledovať tu: {order.public_url}')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', invoice: false, ignore_sources: '', bcc: '' },
            labels: { invoice: __('Pripojiť PDF faktúry ako prílohu') },
        },
        'delivered': {
            name: __('Doručenie zásielky'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('objednávka č. {order.number} bola doručená.')}</p><p>${__('Číslo zásielky: {package.number}')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', invoice: false, ignore_sources: '', bcc: '' },
            labels: { invoice: __('Pripojiť PDF faktúry ako prílohu') },
        },
        'change_state': {
            name: __('Zmena stavu objednávky'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('objednávka č. {order.number} bola zrušená.')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', invoice: false, state: null, delivery_type: '', ignore_sources: '', bcc: '' },
            labels: { invoice: __('Pripojiť PDF faktúry ako prílohu') },
        },
        'accept': {
            name: __('Prijatie objednávky'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('objednávka č. {order.number} bola prijatá.')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', payment_type: '', delivery_type: '', ignore_sources: '', bcc: '' },
        },
        'complaint_waiting': {
            name: __('Reklamácia - prijatá'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('vaša reklamácia k objednávke č. {order.number} bola prijatá. Viac informácii nájdete na tejto stránke {order.public_url}.')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', delivery_type: '', ignore_sources: '', bcc: '' },
        },
        'complaint_processing': {
            name: __('Reklamácia - spracováva sa'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('vaša reklamácia k objednávke č. {order.number} sa spracováva.')}</p><p>${__('Naše vyjadrenie: {complaint.end_text}')}</p><p>${__('Viac informácii nájdete na tejto stránke {order.public_url}.')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', delivery_type: '', ignore_sources: '', bcc: '' },
        },
        'complaint_sent': {
            name: __('Reklamácia - odoslaná'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('vaša reklamácia k objednávke č. {order.number} bola odoslaná. Viac informácii nájdete na tejto stránke {order.public_url}.')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', delivery_type: '', ignore_sources: '', bcc: '' },
        },
        'complaint_ready_pickup': {
            name: __('Reklamácia - pripravená na vyzdvihnutie'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('vaša reklamácia k objednávke č. {order.number} je pripravená na vyzdvihnutie. Viac informácii nájdete na tejto stránke {order.public_url}.')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', delivery_type: '', ignore_sources: '', bcc: '' },
        },
        'complaint_process': {
            name: __('Reklamácia - vybavená'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('vaša reklamácia k objednávke č. {order.number} bola vybavená. Viac informácii nájdete na tejto stránke {order.public_url}.')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', delivery_type: '', ignore_sources: '', bcc: '' },
        },
        'complaint_aborted': {
            name: __('Reklamácia - zamietnutá'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('vaša reklamácia k objednávke č. {order.number} bola zamietnutá.')}</p><p>${__('Naše vyjadrenie: {complaint.end_text}')}</p><p>${__('Viac informácii nájdete na tejto stránke {order.public_url}.')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', delivery_type: '', ignore_sources: '', bcc: '' },
        },
        'public_map': {
            name: __('Mapy - nezvolené výdajné miesto'),
            text: `<p>${__('Dobrý deň,')}</p><p>${__('vo vašej objednávke č. {order.number} nie je zvolené výdajné miesto na doručenie zásielky. Prosím zvoľte si výdajné miesto na tejto stránke {order.map_url}.')}</p><p>${__('S pozdravom,')}</p><p>${__('Eshop.com')}</p>`,
            settings: { delay: '', ignore_sources: '', bcc: '' },
        },
        'custom': {
            name: __('Bez udalosti'),
            text: '',
            settings: { bcc: '', invoice: false },
            labels: { invoice: __('Pripojiť PDF faktúry ako prílohu') },
        },
    };
};
